module.exports = __webpack_public_path__ + "img/cyber2.04740b65.jpg";